import { Component, EventEmitter, Input, Output, CUSTOM_ELEMENTS_SCHEMA, OnInit, OnDestroy, HostListener } from '@angular/core';
import { AemsFile } from '../../../models/aems-file.model';
import { CommonModule } from '@angular/common';
import '@maersk-global/mds-components-core/mc-checkbox';

@Component({
  selector: 'app-file-preview',
  imports: [CommonModule],
  templateUrl: './file-preview.component.html',
  styleUrl: './file-preview.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FilePreviewComponent implements OnInit {
  @Input() files: AemsFile[] = [];
  @Input() type: 'full' | 'compact' = 'full';
  @Input() showLinkFileIcon: boolean = false;
  @Output() thumbnailClicked = new EventEmitter<AemsFile>();
  @Output() fileLinked = new EventEmitter<AemsFile>();

  public screenWidth: number = window.innerWidth;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.screenWidth = event.target.innerWidth;
  }

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
  }

  get numberOfItemsPerRow(): number {
    if (this.screenWidth >= 320 && this.screenWidth < 768) {
      return 4;
    }
    if (this.screenWidth >= 768 && this.screenWidth < 1024) {
      return 7;
    }
    if (this.screenWidth >= 1024 && this.screenWidth < 1280) {
      return 10;
    }
    if (this.screenWidth >= 1280 && this.screenWidth < 1920) {
      return 11;
    }
    if (this.screenWidth >= 1920 && this.screenWidth < 2560) {
      return 12;
    }
    if (this.screenWidth >= 2560 && this.screenWidth < 3840) {
      return 14;
    }
    return 10;
  }

  get groupedFiles(): AemsFile[][] {
    if (this.type === 'compact' || !this.files) {
      return [this.files || []];
    }

    const result: AemsFile[][] = [];
    const itemsPerRow = this.numberOfItemsPerRow;

    for (let i = 0; i < this.files.length; i += itemsPerRow) {
      result.push(this.files.slice(i, i + itemsPerRow));
    }

    return result;
  }

  onThumbnailClicked(file: AemsFile) {
    this.thumbnailClicked.emit(file);
  }
  onFileLinkedChange(file: AemsFile) {
    file.linkFile = !file.linkFile;
    this.fileLinked.emit(file);
  }
}
